import React from "react";
import {
  Users,
  Store,
  ShieldCheck,
} from "lucide-react";

const Paccs = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (!element) return;

    const yOffset = -120;
    const y =
      element.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen flex font-sans">

      {/* ---------------- LEFT FIXED MENU ---------------- */}
      <div className="w-72 pt-28">
        <div className="bg-white shadow-sm border p-6 sticky top-24">
          <h3 className="text-2xl font-bold mb-4 border-b pb-3">
            Cooperative Credit
          </h3>

          <details className="group mb-4">
            <summary className="flex justify-between items-center cursor-pointer list-none">
              <button
                onClick={() => scrollToSection("paccs-heading")}
                className="text-lg font-medium hover:text-blue-600"
              >
                PACCS
              </button>
              <span className="group-open:rotate-180 transition">▼</span>
            </summary>

          <div className="pl-4 mt-2 space-y-2 text-blue-600">
  <button onClick={() => scrollToSection("paccs-overview")} className="block text-left">
    Overview
  </button>

  <button onClick={() => scrollToSection("paccs-services")} className="block text-left">
    Key Services
  </button>

  <button onClick={() => scrollToSection("paccs-governance")} className="block text-left">
    Governance
  </button>
</div>

          </details>

          <details className="group">
            <summary className="flex justify-between items-center cursor-pointer list-none">
              <button
                onClick={() => scrollToSection("uccs-heading")}
                className="text-lg font-medium hover:text-blue-600"
              >
                UCCS
              </button>
              <span className="group-open:rotate-180 transition">▼</span>
            </summary>

           <div className="pl-4 mt-2 space-y-2 text-blue-600">
  <button onClick={() => scrollToSection("uccs-overview")} className="block text-left">
    Overview
  </button>

  <button onClick={() => scrollToSection("uccs-offers")} className="block text-left">
    What UCCs Offer
  </button>

  <button onClick={() => scrollToSection("uccs-governance")} className="block text-left">
    Governance & Membership
  </button>
</div>

          </details>
        </div>
      </div>

      {/* ---------------- RIGHT CONTENT ---------------- */}
      <div className="flex-1 bg-blue-100 overflow-y-auto">

        {/* ================= PACCS ================= */}
        <section>
          <header id="paccs-heading" className="py-14 text-center bg-white">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900">
              Primary Agricultural Cooperative Credit Societies (PACCS)
            </h1>
          </header>

          <div id="paccs-overview" className="px-6 lg:px-16 py-12">
            <div className="bg-white p-8 rounded-xl shadow border-l-4 border-blue-500">
              <h2 className="text-2xl lg:text-3xl font-semibold mb-5">
                Overview
              </h2>
              <p className="text-lg lg:text-xl text-gray-700 leading-relaxed">
                Primary Agricultural Cooperative Credit Societies (PACCS) form the
                grassroots layer of Tamil Nadu’s cooperative credit system. They
                operate at the village level and provide farmers with timely and
                affordable access to credit, inputs, and essential agricultural
                support services.
              </p>
            </div>
          </div>

<div
  id="paccs-services"
  className="px-6 lg:px-16 pb-14 bg-white pt-12"
>

  <h3 className="text-2xl lg:text-3xl font-semibold mb-8 text-gray-900">
    Key Services
  </h3>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
    {[
      {
        text: "Short-term and medium-term agricultural loans",
        bg: "bg-blue-900/90",
        icon: "text-blue-900",
      },
      {
        text: "Support for seeds, fertilisers, and farm machinery",
        bg: "bg-slate-800",
        icon: "text-slate-800",
      },
      {
        text: "Credit for irrigation, livestock, and allied activities",
        bg: "bg-sky-900/90",
        icon: "text-sky-900",
      },
      {
        text: "Loan repayment and member financial services",
        bg: "bg-blue-900/90",
        icon: "text-blue-900",
      },
      {
        text: "Distribution of inputs & local agricultural marketing",
        bg: "bg-slate-800",
        icon: "text-slate-800",
      },
    ].map((item, i) => (
      <div
        key={i}
        className={`${item.bg} p-7 rounded-2xl border border-white/10 shadow-lg hover:shadow-xl transition`}
      >
        <div className="flex items-start gap-4">
          <div className="p-3 rounded-xl bg-white shadow-md">
            <ShieldCheck className={`w-7 h-7 ${item.icon}`} />
          </div>

          <p className="text-lg lg:text-xl text-white leading-relaxed font-medium">
            {item.text}
          </p>
        </div>
      </div>
    ))}
  </div>
</div>
<div id="paccs-governance" className="px-6 lg:px-16 py-14 bg-white ">
  <div className="max-w-6xl mx-auto">
    <div className="bg-blue-100 border border-blue-800/40 text-black p-10 rounded-2xl shadow-xl">
      
      {/* Title */}
      <div className="flex items-center gap-4 mb-6">
        <div className="w-1.5 h-12 bg-blue-600 rounded-full" />
        <h3 className="text-2xl lg:text-3xl font-semibold tracking-wide">
          Governance
        </h3>
      </div>

      {/* Content */}
      <p className="text-lg lg:text-xl leading-relaxed text-balck max-w-4xl">
        PACCS are member-owned institutions governed by an elected
        <span className="font-semibold text-black">
          {" "}Management Committee
        </span>. Decisions are taken democratically through the
        <span className="font-semibold text-black">
          {" "}General Body
        </span>.
      </p>
    </div>
  </div>
</div>

        </section>

        {/* ================= UCCS ================= */}
        <section>
          <header id="uccs-heading" className="py-14 text-center bg-white ">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900">
              Urban Cooperative Credit Societies (UCCs)
            </h1>
          </header>

          <div id="uccs-overview" className="px-6 lg:px-16 py-12">
            <div className="bg-white p-8 rounded-xl shadow border-l-4 border-blue-500">
              <h2 className="text-2xl lg:text-3xl font-semibold mb-5">
                Overview
              </h2>
              <p className="text-lg lg:text-xl text-gray-700 leading-relaxed">
                Urban Cooperative Credit Societies (UCCs) serve as community-based
                financial institutions offering savings and credit services to
                households, small traders, and working professionals in urban
                and semi-urban areas.
              </p>
            </div>
          </div>
<div
  id="uccs-offers"
  className="px-6 lg:px-16 pb-14 bg-white pt-8"
>

  <h3 className="text-2xl lg:text-3xl font-semibold mb-8 text-gray-900">
    What UCCs Offer
  </h3>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
    {[
      {
        text: "Savings accounts and deposit schemes",
        bg: "bg-blue-900/90",
        icon: "text-blue-900",
      },
      {
        text: "Personal, business & pledge loans",
        bg: "bg-slate-800",
        icon: "text-slate-800",
      },
      {
        text: "Credit for small and micro enterprises",
        bg: "bg-sky-900/90",
        icon: "text-sky-900",
      },
      {
        text: "Tailored financial products for urban communities",
        bg: "bg-blue-900/90",
        icon: "text-blue-900",
      },
    ].map((item, i) => (
      <div
        key={i}
        className={`${item.bg} p-7 rounded-2xl border border-white/10 shadow-lg hover:shadow-xl transition`}
      >
        <div className="flex items-start gap-4">
          <div className="p-3 rounded-xl bg-white shadow-md">
            <Store className={`w-7 h-7 ${item.icon}`} />
          </div>

          <p className="text-lg lg:text-xl text-white leading-relaxed font-medium">
            {item.text}
          </p>
        </div>
      </div>
    ))}
  </div>
</div>

         <div id="uccs-governance" className="px-6 lg:px-16 py-14 bg-white -mt-10">
  <div className="max-w-6xl mx-auto">
    <div className="bg-blue-100 border border-blue-800/40 text-white p-10 rounded-2xl shadow-xl">
      
      {/* Title */}
      <div className="flex items-center gap-4 mb-6">
        <div className="w-1.5 h-12 bg-blue-600 rounded-full" />
        <h3 className="text-2xl lg:text-3xl font-semibold tracking-wide text-black">
          Governance & Membership
        </h3>
      </div>

      {/* Content */}
      <p className="text-lg lg:text-xl leading-relaxed text-black max-w-4xl">
        UCCs are cooperative institutions managed by
        <span className="font-semibold text-black">
          {" "}elected committees
        </span>. Membership is open to individuals
        <span className="font-semibold text-black">
          {" "}residing or working in the locality
        </span>, ensuring
        <span className="font-semibold text-black">
          {" "}community ownership and participation
        </span>.
      </p>
    </div>
  </div>
</div>

        </section>
      </div>
    </div>
  );
};

export default Paccs;
